import React, { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Container,
  makeStyles,
  Paper,
  Slider,
  Tooltip,
  Typography,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import MainToolbar from "../MainToolbar";
import Map from "../map/Map";
import t from "../common/localization";
import ReplayPathMap from "../map/ReplayPathMap";
import PositionsMap from "../map/PositionsMap";
import { formatPosition } from "../common/formatter";
import ReportFilter from "./ReportFilter";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import RestoreIcon from '@material-ui/icons/Restore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "row",
  },
  controlPanel: {
    position: "absolute",
    bottom: theme.spacing(4),
    left: "50%",
    transform: "translateX(-50%)",
  },
  button: {
      border: 0,
      borderRadius: 18,
      boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
      height: "30px",
      width: "40px",
      color: 'red',
      margin: '3px',
      // padding: '0 20px',
    },
  controlContent: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(3),
    width: "100%",
  },
  configForm: {
    display: "flex",
    flexDirection: "column",
  },
  speedSlider: {
  display: "flexEnd",
      flexDirection: "row",
 marginLeft: "80px",
 marginBottom: "-10px",
    width: 200,
  },
}));
let sliderInterval = null;
const TimeLabel = ({ children, open, value }) => {
  return (
    <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
      {children}
    </Tooltip>
  );
};

const ReplayPage = () => {
  const classes = useStyles();

  const [expanded, setExpanded] = useState(true);
  const [positions, setPositions] = useState([]);
  const [index, setIndex] = useState(0);
  const [speed, setSpeed] = useState(300);

  const handleSubmit = async (deviceId, from, to, _, headers) => {
    const query = new URLSearchParams({ deviceId, from, to });
    const response = await fetch(`/api/positions?${query.toString()}`, {
      headers,
    });
    if (response.ok) {
      setIndex(0);
      setPositions(await response.json());
      setExpanded(false);
    }
  };
  const playSlider = () => {
    let i = index;
    sliderInterval = setInterval(() => {
      if (i >= positions.length) {
        clearInterval(sliderInterval);
        return;
      }
      setIndex(i++);
    }, speed);
  };
  const stopSlider = () => {
    sliderInterval && clearInterval(sliderInterval);
    sliderInterval = null;
  };

  const resetSlider = () => {
    stopSlider();
    setIndex(0);
  };
  const valueText = (value) => {
    return `${value}x`;
  };
  const handleSliderChange = (event) => {
    const value = event.target.value === "" ? 1 : Number(event.target.value);
    setSpeed(300 / value);
    stopSlider();
    setTimeout(() => {
      playSlider();
    }, 200);
  };
  return (
    <div className={classes.root}>
      <MainToolbar />
      <Map>
        <ReplayPathMap positions={positions} />
        {index < positions.length && (
          <PositionsMap positions={[positions[index]]} />
        )}
      </Map>
      <Container maxWidth="sm" className={classes.controlPanel}>
        {!!positions.length && (
          <Paper className={classes.controlContent}  elevation={4}>
            <Slider
              max={positions.length - 1}
              step={null}
              marks={positions.map((_, index) => ({ value: index }))}
              value={index}
              onChange={(_, index) => {
                setIndex(index);
              }}
              valueLabelDisplay="auto"
              valueLabelFormat={(i) =>
                i < positions.length
                  ? formatPosition(positions[i], "fixTime")
                  : ""
              }
              ValueLabelComponent={TimeLabel}
            />
          </Paper>
        )}
        <div className={classes.root}>
        <Paper className={classes.controlContent} elevation={4}>
        <Button color="primary" onClick={playSlider} className= {classes.button}>
        <PlayArrowIcon color="primary" />
          {" "}
        </Button>
        <Button color="primary" onClick={stopSlider} className= {classes.button}>
        <PauseIcon color="primary" />
          {" "}
        </Button>
        <Button color="primary" onClick={resetSlider} className= {classes.button}>
        <RestoreIcon color="primary"/>
         </Button>
        <Slider className={classes.speedSlider}
              defaultValue={1}
              getAriaValueText={valueText}
              // aria-labelledby="discrete-slider-small-steps"
              step={1}
              marks
              min={1}
              max={5}
              aria-labelledby="discrete-slider-always"
              valueLabelDisplay="auto"
              onChange={handleSliderChange} />
            </Paper>
            </div>
        <div>
          <Accordion
            expanded={expanded}
            onChange={() => setExpanded(!expanded)}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography align="center">{t("reportConfigure")}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.configForm}>
              <ReportFilter handleSubmit={handleSubmit} showOnly />
            </AccordionDetails>
          </Accordion>
        </div>
      </Container>
    </div>
  );
};

export default ReplayPage;
